import { ApplicationStatusEnum } from '../../lib/types/enums/enrollment/application-status.enum'
import { EnrollmentFilter } from '../../lib/types/models/enrollment/enrollment-filter'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type EnrollmentDistributionResponse = {
  normalIndividuals: number
  cse: number
}

export function getEnrollmentsDistribution(
  input?: EnrollmentFilter
): Promise<EnrollmentDistributionResponse> {
  return restApiClient
    .url(encodeNestedObject<EnrollmentFilter>(API.enrollments.getDistribution.url, input))
    .get<EnrollmentDistributionResponse>()
}

export function getEnrollmentsStatusesDistribution(
  input?: EnrollmentFilter
): Promise<Partial<Record<ApplicationStatusEnum, number>>> {
  return restApiClient
    .url(encodeNestedObject<EnrollmentFilter>(API.enrollments.getStatusesDistribution.url, input))
    .get<Partial<Record<ApplicationStatusEnum, number>>>()
}
